import React from "react";
import { useParams } from "react-router-dom";

import { Header, Loader } from "semantic-ui-react";

import useClient from "data/hub/clients/useClient";

import { useClientCardNextWorkflows } from "./hooks";
import NextWorkflowTile from "./NextWorkflowTile";
import WorkflowTile from "./WorkflowTile";

function CardNextWorkflows() {
  const { clientId, workflowId } = useParams();
  const clientState = useClient(clientId);
  const { loading, clientWorkflows } = useClientCardNextWorkflows(
    clientId,
    clientState.workflows
  );

  const cws = Object.entries(clientWorkflows)
    .filter(([cwId]) => {
      return clientState.workflows.includes(cwId);
    })
    .map(([_, cw]) => {
      return cw;
    });

  const unaffiliatedWorkflows = cws
    .filter(({ completed }) => {
      return completed;
    })
    .flatMap(({ nextWorkflows }) => {
      if (!nextWorkflows) {
        console.warn(
          "nextWorkflows is undefined when attempting to collect unaffiliated workflows"
        );

        return [];
      }

      return nextWorkflows;
    })
    .filter(({ startDate }) => {
      return startDate;
    });

  const numActiveWorkflows = cws.filter(({ completed }) => {
    return !completed;
  }).length;

  return (
    <React.Fragment>
      {numActiveWorkflows > 0 && (
        <div
          data-test="client-card-workflow-chain"
          style={{ marginTop: "0.5em" }}
        >
          <header
            style={{
              marginBottom: "0.5em",
              display: "flex",
              gap: "0.5em",
            }}
          >
            <Header as="h5" style={{ marginBottom: "0" }}>
              Workflows
            </Header>

            {loading && (
              <Loader size="mini" inline className="invertedLoader" />
            )}
          </header>
          {clientState.workflows.map((clientWorkflowId) => {
            return (
              <WorkflowTile
                key={clientWorkflowId}
                bold={clientWorkflowId === workflowId}
                client={clientState}
                clientWorkflowId={clientWorkflowId}
              />
            );
          })}
        </div>
      )}
      {unaffiliatedWorkflows.length > 0 && (
        <div style={{ marginTop: "1em" }}>
          <header
            style={{
              marginBottom: "0.5em",
              display: "flex",
              gap: "0.5em",
            }}
          >
            <Header as="h5" style={{ marginBottom: "0" }}>
              Scheduled Next Workflows
            </Header>

            {loading && (
              <Loader size="mini" inline className="invertedLoader" />
            )}
          </header>

          {unaffiliatedWorkflows.map((wf) => {
            return (
              <NextWorkflowTile
                key={wf.id}
                client={clientState}
                nextWorkflow={wf}
                style={{ marginBottom: "1em" }}
              />
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
}

export default CardNextWorkflows;
